import React from 'react';
import { Modal, Stack, Text, Center } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import { AddCalendarAccount } from './AddCalendarAccount';
import { CalendarProvider } from '../utils/common';

interface ReconnectAccountModalProps {
    opened: boolean;
    onClose: () => void;
    accountName: string;
    provider: CalendarProvider;
}

const ReconnectAccountModal: React.FC<ReconnectAccountModalProps> = ({
    opened,
    onClose,
    accountName,
    provider,
}) => {
    const { t } = useTranslation(['app']);

    return (
        <Modal
            opened={opened}
            onClose={onClose}
            title={t('dashboard.calendar_inaccessible.reconnect_modal_title')}
            centered
        >
            <Stack gap="md">
                <Text>
                    {t('dashboard.calendar_inaccessible.reconnect_modal_body', { name: accountName })}
                </Text>
                <Center>
                    <AddCalendarAccount
                        provider={provider}
                        isConnected={true}
                        glowing={false}
                        withTos={false}
                    />
                </Center>
            </Stack>
        </Modal>
    );
};

export default ReconnectAccountModal;
